import { Icon } from './icon';

export const IconChild = () => (
  <Icon>
    <rect x="9" y="4" width="6" height="6" rx="1" />
    <rect x="4" y="14" width="6" height="6" rx="1" />
    <rect x="14" y="14" width="6" height="6" rx="1" />
  </Icon>
);
